import { ContentfulClientApi, createClient } from 'contentful';

const space = import.meta.env.VITE_CONTENTFUL_SPACE_ID as string || '';
const accessToken = import.meta.env.VITE_CONTENTFUL_ACCESS_TOKEN as string || '';

let client: ContentfulClientApi<undefined> | null = null;

export function getContentfulClient(): ContentfulClientApi<undefined> {
  if (!client) {
    if (!space || !accessToken) {
      console.warn('Contentful credentials not configured. Set VITE_CONTENTFUL_SPACE_ID and VITE_CONTENTFUL_ACCESS_TOKEN environment variables.');
      // Return a mock client for development
      return createClient({
        space: 'mock',
        accessToken: 'mock',
      });
    }

    client = createClient({
      space,
      accessToken,
    });
  }

  return client;
}

export async function getEntries(contentType: string) {
  const client = getContentfulClient();
  try {
    const entries = await client.getEntries({
      content_type: contentType,
    });
    return entries.items as any[];
  } catch (error) {
    console.error('Error fetching entries:', error);
    return [];
  }
}

export async function getEntry(entryId: string) {
  const client = getContentfulClient();
  try {
    const entry = await client.getEntry(entryId);
    return entry as any;
  } catch (error) {
    console.error('Error fetching entry:', error);
    return null;
  }
}
